export const transformChallenges = (challengesState) => {
    if (challengesState && challengesState.length) {
        return challengesState.map((challenge) => {
            return {
                id: challenge.id,
                title: challenge.name,
                isGlobal: challenge.isGlobal,
            };
        });
    } else {
        return [];
    }
};

export const transformTags = (tagsState) => {
    if (tagsState && tagsState.length) {
        tagsState = tagsState.filter((tag) => tag.tags);
        return tagsState.map((tag) => {
            return {
                id: tag.id,
                title: tag.tags,
            };
        });
    } else {
        return [];
    }
};

export const transformUsers = (usersState) => {
    if (usersState && usersState.length) {
        return usersState
            .filter((user) => user.fullName)
            .map((user) => {
                return {
                    id: user.id,
                    title: `${user.fullName} [${user.username}]`,
                };
            });
    } else {
        return [];
    }
};

export const transformCountries = (countriesState) => {
    if (countriesState && countriesState.length) {
        return countriesState.map((country) => {
            return {
                id: country.countryCode,
                title: country.country ? country.country : country.countryCode,
            };
        });
    } else {
        return [];
    }
};

export const transformCities = (countries, selectedIds) => {
    if (countries && countries.length && selectedIds && selectedIds.length) {
        return countries
            .filter(
                (country) =>
                    selectedIds.indexOf(country.countryCode) > -1 &&
                    country.cities,
            )
            .map((country) => country.cities)
            .reduce((cities, city) => {
                cities.push(...city);
                return cities;
            }, [])
            .map((country) => {
                return {
                    id: country.name,
                    title: country.name,
                };
            });
    } else {
        return [];
    }
};

export const transformReportData = (impactLitters) => {
    if (impactLitters && impactLitters.length) {
        return impactLitters.map((litter) => {
            return {
                ...litter,
                litterCount: litter.litterCount,
                category: litter.objectCategory,
                object: litter.litteratiObject,
                material: litter.litteratiMaterial,
                brand: litter.litteratiBrand,
                other: litter.litteratiOther,
                unclassified: litter.unclassified,
            };
        });
    } else {
        return [];
    }
};
